/**
 * Kinng.app — Lista de Espera API.
 */
import api from "./api";

export const waitlistApi = {
    list: (status = "all") => {
        const qs = status && status !== "all" ? `?status=${status}` : "";
        return api.get(`/tenant/waitlist${qs}`);
    },
    summary: () => api.get("/tenant/waitlist/summary"),
    add: (body) => api.post("/tenant/waitlist", body),
    remove: (id) => api.del(`/tenant/waitlist/${id}`),
    notify: (id) => api.post(`/tenant/waitlist/${id}/notify`, {}),
    schedule: (id, body) => api.post(`/tenant/waitlist/${id}/schedule`, body),
    publicJoin: (shopId, body) =>
        fetch(`${(process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "")}/api/public/${shopId}/waitlist`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(body),
        }).then(async (r) => {
            const data = await r.json();
            if (!r.ok) throw new Error(data.detail || `HTTP ${r.status}`);
            return data;
        }),
};

export default waitlistApi;
